import Visible from '@portalterreno/react-ui/Visible';
import React from 'react';

import TermsAndConditions from '../../TermsAndConditions';
import DesktopFooter from './DesktopFooter';

export type FooterProps = React.HTMLAttributes<HTMLDivElement>;

const Footer: React.FC<FooterProps> = (props) => {
  return (
    <React.Fragment>
      <Visible desktop>
        <DesktopFooter {...props} />
      </Visible>
      <TermsAndConditions />
    </React.Fragment>
  );
};

export default Footer;
